import { Traits } from "./Traits";
import { SlotTraitInfo } from "./SlotTraitInfo";
var ExceptionInfo = /** @class */ (function () {
    function ExceptionInfo(abc, start, end, target, type, varName) {
        this.abc = abc;
        this.start = start;
        this.end = end;
        this.target = target;
        this.type = type;
        this.varName = varName;
        this.catchPrototype = null;
        this._traits = null;
        // ...
    }
    ExceptionInfo.prototype.getType = function () {
        if (typeof this.type === "number") {
            this.type = this.abc.getMultiname(this.type);
        }
        return this.type;
    };
    ExceptionInfo.prototype.getTraits = function () {
        if (!this._traits) {
            var traits = [];
            if (this.varName) {
                traits.push(new SlotTraitInfo(this.abc, 0 /* Slot */, this.varName, 1, this.type, 0, 0));
            }
            this._traits = new Traits(traits);
            this._traits.resolve();
        }
        return this._traits;
    };
    return ExceptionInfo;
}());
export { ExceptionInfo };
